// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { Card, Column, LgPadding } from '@alto/design-system';
import { ContactUs } from '@alto/features';
import React from 'react';
import styled from 'styled-components';
import { CONTACT_US_ORIGIN, IMG_ALT_TEXTS } from '~shared/constants';
import { CONTACT_SUPPORT_HEADER, SEND_MESSAGE_FORK } from '~shared/features/profile/constants';
import { BusinessHours } from './BusinessHours';
import { Breadcrumbs } from '~web/components/Breadcrumbs';
import { PageBackground, Sidebar } from '~web/components/Page';
import { PageHeader } from '~web/components/PageHeader';
import pillBottle from '~web/images/pillBottle@3x.png';

export type Props = {
  readonly openMessages: () => void;
};

const StyledSidebar = styled(Sidebar)`
  max-width: 25em;
`;

const BREADCRUMBS = [
  {
    text: 'Account',
    to: '/me',
  },
  {
    text: 'Contact support',
  },
];

export const ProfileContactSupport = () => {
  return (
    <PageBackground>
      <StyledSidebar>
        <Column
          flexShrink={1}
          gap="LG"
        >
          <Column>
            <Breadcrumbs breadcrumbs={BREADCRUMBS} />
            <PageHeader>Contact support</PageHeader>
          </Column>
          <Card
            title={CONTACT_SUPPORT_HEADER.TITLE}
            description={SEND_MESSAGE_FORK.BODY}
            illustrationSrc={pillBottle}
            illustrationAccessibilityLabel={IMG_ALT_TEXTS.pillBottle}
            flexGrow={0}
          >
            <LgPadding topPadding={SPACING.STATIC.NONE}>
              <ContactUs
                type="link"
                method="message"
                customLabel="Send us a message"
                origin={CONTACT_US_ORIGIN.ProfileSupport}
              />
            </LgPadding>
          </Card>
          <BusinessHours />
        </Column>
      </StyledSidebar>
    </PageBackground>
  );
};
